import styled from 'styled-components'
import { Form, Icon } from 'antd'

import { Link } from 'src/components/Ant'

export const WrapForm = styled(Form)`
  width: 368px;
`

export const WrapIcon = styled(Icon)`
  color: rgba(0, 0, 0, 0.25);
`

export const WrapLink = styled(Link)`
  float: right;
`
